import { z } from 'zod';

import { TeamSpecialistRoleId } from '../BrandedIds';

export const TeamSpecialistRole = z.object({
  id: TeamSpecialistRoleId,
  title: z.string(),
  key: z.string(), // unique key for bulk update report
});

export type TeamSpecialistRole = z.infer<typeof TeamSpecialistRole>;
